import React from 'react';
import { format } from 'date-fns';
import _isEmtpy from 'lodash/isEmpty';
import { ACCESSIBILITY_LINK_MAP } from './CopyrightLabel.constants';
import OutboundLink from '../../atoms/OutboundLink';
import { FISHERMAN_BRAND_IDENTITY } from '../../constants';
import { BrandPropType } from '../../services/proptypes';
import './CopyrightLabel.css';
var defaultProps = {
  company: '',
  phrase: '',
  year: null,
  privacyPolicyLink: null,
  brand: FISHERMAN_BRAND_IDENTITY,
  accessibilityLink: null
};
export default function CopyrightLabel(_ref) {
  var year = _ref.year,
    company = _ref.company,
    phrase = _ref.phrase,
    privacyPolicyLink = _ref.privacyPolicyLink,
    accessibilityLink = _ref.accessibilityLink,
    brand = _ref.brand;
  function getAccessibilityLink(brandIdentity, linkElement) {
    if (!_isEmtpy(linkElement)) {
      return linkElement;
    }
    var url = ACCESSIBILITY_LINK_MAP[brandIdentity];
    return /*#__PURE__*/React.createElement(OutboundLink, {
      to: url,
      label: "Accessibility Statement",
      eventLabel: "copyright-accessibility-statement"
    });
  }
  var accessibilityLinkElement = getAccessibilityLink(brand, accessibilityLink);
  return /*#__PURE__*/React.createElement("div", {
    className: "fc-copyright-label"
  }, /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": "Copyright"
  }, "\xA9"), /*#__PURE__*/React.createElement("span", null, year || format(new Date(), 'yyyy'), " ", company, " ", phrase), /*#__PURE__*/React.createElement(React.Fragment, null, (privacyPolicyLink || accessibilityLinkElement) && /*#__PURE__*/React.createElement("br", null), accessibilityLinkElement && /*#__PURE__*/React.createElement("span", {
    className: "accessibility-link"
  }, accessibilityLinkElement), privacyPolicyLink && accessibilityLinkElement && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0\xA0"), privacyPolicyLink && /*#__PURE__*/React.createElement("span", {
    className: "privacy-policy-link"
  }, privacyPolicyLink)));
}
CopyrightLabel.defaultProps = defaultProps;